module.exports = {
   baseURL : '/api',//'https://asset.resmanmobile.co.nz/api',
   homeURL: '', //'https://asset.resmanmobile.co.nz',
};
